<template>
  <div class="setting-main-container">
    <form action="" class="mt-3" @submit.prevent="submitBusinessData">
      <div class="card setting-card">
        <div class="page-header">
          <h3 class="page-title">{{ $t('profile.business_nature.business_nature') }}</h3>
        </div>     
        <div class="row">
          <div class="col-md-12 mb-4 form-group">
            <label class="input-label">{{ $tc('profile.borrowerProfile.businessDetails.business_name') }}</label><span class="text-danger"> * </span>
              <base-input
                v-model="formData.name"
                @input="$v.formData.name.$touch()"
              />
              <div v-if="$v.formData.name.$error">
                <span v-if="!$v.formData.name.required" class="text-danger">
                  {{ $tc('validation.required') }}
                </span>
              </div>
          </div>
          <div class="col-md-12 mb-4 form-group">
            <label class="input-label">{{ $tc('profile.borrowerProfile.businessDetails.address') }}</label><span class="text-danger"> * </span>
              <base-input
                v-model="formData.address"
                @input="$v.formData.address.$touch()"
              />
              <div v-if="$v.formData.address.$error">
                <span v-if="!$v.formData.address.required" class="text-danger">
                  {{ $tc('validation.required') }}
                </span>
              </div>
          </div>
          <div class="col-md-12 mb-4 form-group">
            <label class="input-label">{{ $tc('profile.borrowerProfile.businessDetails.business_phone') }}</label><span class="text-danger"> * </span>
            <base-input
              v-model="formData.phone"
              @input="$v.formData.phone.$touch()"
            />
            <div v-if="$v.formData.phone.$error">
              <span v-if="!$v.formData.phone.required" class="text-danger">
                {{ $tc('validation.required') }}
              </span>
            </div>
          </div>
          <div class="col-md-6 mb-4 form-group">
            <label class="input-label">{{ $tc('profile.borrowerProfile.businessDetails.sales_tax_num') }}</label>
              <base-input
                v-model="formData.sale_tax"
                 @input="$v.formData.sale_tax.$touch()"
              />
              <div v-if="$v.formData.sale_tax.$error">
              <span v-if="!$v.formData.sale_tax.numeric" class="text-danger">
                {{ $tc('validation.numbers_only') }}
              </span>
            </div> 
          </div>
          <div class="col-md-6 mb-4 form-group">
            <label class="input-label">{{ $tc('profile.borrowerProfile.businessDetails.email') }}</label>
            <base-input
              v-model="formData.email"
              @input="$v.formData.email.$touch()"
            />
            <div v-if="$v.formData.email.$error">
              <span v-if="!$v.formData.email.email" class="text-danger">
                {{ $tc('validation.email_incorrect') }}
              </span>
            </div>     
          </div>
          <div class="col-md-6 mb-4 form-group">
            <label class="input-label">{{ $tc('profile.borrowerProfile.businessDetails.importing_registration') }}</label>
            <base-input v-model="formData.importing_registration" />    
          </div>
          <div class="col-md-6 mb-4 form-group">
            <label class="input-label">{{ $tc('profile.borrowerProfile.businessDetails.exporting_registration') }}</label>
            <base-input v-model="formData.exporting_registration" />
          </div>
          <div class="col-md-6 mb-4 form-group">
            <label class="input-label">{{ $tc('profile.borrowerProfile.businessDetails.date_establishment') }}</label><span class="text-danger"> * </span>
            <base-date-picker
              :calendar-button="true"
              calendar-button-icon="calendar"
              v-model="formData.date_establishment"
              @change="$v.formData.date_establishment.$touch()"
            />
            <div v-if="$v.formData.date_establishment.$error">
              <span v-if="!$v.formData.date_establishment.required" class="text-danger">
                {{ $tc('validation.required') }}
              </span>
            </div>
          </div>
          <div class="col-md-6 mb-4 form-group">
            <label class="input-label">{{ $tc('profile.borrowerProfile.businessDetails.date_opening_ac') }}</label><span class="text-danger"> * </span>
            <base-date-picker
                :calendar-button="true"
                calendar-button-icon="calendar"
                v-model="formData.date_openingAc"
                @change="$v.formData.date_openingAc.$touch()"
            />
              <div v-if="$v.formData.date_openingAc.$error">
              <span v-if="!$v.formData.date_openingAc.required" class="text-danger">
                {{ $tc('validation.required') }}
              </span>
            </div>
          </div>
        </div>
        <div class="row pb-3">
          <div class="col-md-12">
            <base-button
              icon="save"
              color="theme"
              type="submit"
             >
              {{ $t('settings.customization.save') }}
            </base-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
const { required, numeric,maxLength, alpha,minLength,email } = require('vuelidate/lib/validators')
export default {
  mixins: [validationMixin],
  data () {
    return {
      activeTab: 'BUSINESSDETAILS',
      formData:{
        id:null,
        name:null,
        email:null,
        address:null,
        sale_tax:null,
        date_establishment:null,
        date_openingAc:null,
        importing_registration:null,
        exporting_registration:null,
      }
    }
  },
  computed: {
    ...mapGetters('stakeholder', [
      'stakeholders'
    ]),
     ...mapGetters('business', [
      'business'
    ]),
   
  },   
  watch: {
  },
  validations: {
     formData: {
       name: { required,minLength: minLength(3) },
       address: { required },
       phone: { required },
       email: {  email },
       sale_tax: {  numeric },
       date_establishment: {  required },
       date_openingAc: {  required },
    }
  },
  created() {
    if(this.business){ this.formData.id=this.business.id }  
    if(this.business && this.business.name){ this.formData.name=this.business.name }
    if(this.business && this.business.address){ this.formData.address=this.business.address }
    if(this.business && this.business.phone){ this.formData.phone=this.business.phone }
    if(this.business && this.business.sale_tax){ this.formData.sale_tax=this.business.sale_tax }
    if(this.business && this.business.importing_registration){ this.formData.importing_registration=this.business.importing_registration }
    if(this.business && this.business.exporting_registration){ this.formData.exporting_registration=this.business.exporting_registration } 
    if(this.business && this.business.date_openingAc){ this.formData.date_openingAc=  moment(this.business.date_openingAc, 'YYYY-MM-DD').toString()  } 
    if(this.business && this.business.date_establishment){ this.formData.date_establishment= moment(this.business.date_establishment, 'YYYY-MM-DD').toString()  }       
  },
  methods: {
    ...mapActions('modal', [
      'openModal'
    ]),
    ...mapActions('business', [
      'addBusiness',
      'updateBusiness'
    ]),  
    async submitBusinessData(){
        this.$v.formData.$touch()
        if (this.$v.$invalid) {
            return true
        }
        let response = await this.addBusiness(this.formData)
        if (response.data) { 
            this.isLoading = false
            window.toastr['success'](this.$tc('profile.borrowerProfile.businessDetails.saved_message'))
            return true
        }
    }
  }
}
</script>
